import axios from "axios";
import { BUILD_ID as _GENERATED_BUILD_ID, BUILD_AT as _GENERATED_BUILD_AT } from "../build_id.generated";
import { getBrowserId } from "./browserId";
import { clientPlatformHeader, webOnlyWithCredentials } from "./nativePlatform";
import { getToken } from "./nativeTokenStorage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Iter 59 / 59.1 — Frontend build identifier. Generated by
// `scripts/generate-build-id.js` (runs on `yarn start` and `yarn build`
// via the prestart/prebuild hooks) → written to
// `src/build_id.generated.js`. That file's BUILD_ID is the source of
// truth; if for some reason the generated file is missing or stale,
// we fall back to `process.env.REACT_APP_BUILD_ID` and finally to
// "dev-unknown". Logged on every request via X-Frontend-Build-Id.
export const FRONTEND_BUILD_ID =
  _GENERATED_BUILD_ID
  || process.env.REACT_APP_BUILD_ID
  || "dev-unknown";

export const FRONTEND_BUILD_AT = _GENERATED_BUILD_AT || null;

const api = axios.create({
  baseURL: API,
  withCredentials: webOnlyWithCredentials(),
  headers: {
    "Content-Type": "application/json",
    "X-Frontend-Build-Id": FRONTEND_BUILD_ID,
  },
});

// Attach bearer token for JWT users (cookies handle Google users automatically)
api.interceptors.request.use((cfg) => {
  // Iter XX.177 — read via nativeTokenStorage.getToken() so on native
  // the token comes from Keychain / EncryptedSharedPreferences (via
  // in-memory cache), not from plaintext localStorage. On web this
  // resolves to the same localStorage.getItem("gully_token") as
  // before — byte-for-byte identical behavior.
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  // Re-stamp on every request — axios `headers` defaults are not
  // always merged when a caller passes a custom headers object.
  cfg.headers["X-Frontend-Build-Id"] = FRONTEND_BUILD_ID;
  // Iter XX.26 — persistent browser identity. Sent on every request
  // so the backend can lazy-create web_sessions with browser_id
  // stamped, and can bulk-claim anonymous rows on this browser after
  // sign-in via POST /api/web/sessions/claim.
  try {
    const bid = getBrowserId();
    if (bid) cfg.headers["X-Browser-Id"] = bid;
  } catch { /* browserId unavailable — proceed without */ }
  // Iter XX.176 — Client-platform header so the backend can attribute
  // analytics + (Phase 2) refuse web-only checkout paths to native
  // callers. Always resolves — 'web' on browsers, 'ios' / 'android'
  // inside the Capacitor shell. Zero runtime cost on web.
  try {
    cfg.headers["X-Client-Platform"] = clientPlatformHeader();
  } catch { /* platform detection unavailable — proceed */ }
  // Iter XX.262 — Temporal Intelligence V1. Send device IANA timezone
  // on every request so the backend can resolve player-local time
  // deterministically. Zero PII (timezone alone is not identifying).
  // Backend validates against the IANA database; unknown/invalid
  // values are silently ignored and fall back to UTC.
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz) cfg.headers["X-Player-Timezone"] = tz;
  } catch { /* Intl unavailable — proceed without */ }
  return cfg;
});

export default api;
